import React, { useState } from 'react';
import {
  Box,
  SpaceBetween,
  Checkbox,
  Grid,
  Button
} from '@amzn/awsui-components-react';
import HourlyTab from './HourlyTab';

const Val = ({ children }) => <Box variant="span" fontWeight="bold">{children}</Box>;

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const WeeklyTab = ({ isViewMode, onConfigChange, initialConfig = {} }) => {
  const [weeklyMonday, setWeeklyMonday] = useState(true);
  const [weeklyTuesday, setWeeklyTuesday] = useState(true);
  const [weeklyWednesday, setWeeklyWednesday] = useState(true);
  const [weeklyThursday, setWeeklyThursday] = useState(true);
  const [weeklyFriday, setWeeklyFriday] = useState(true);
  const [weeklySaturday, setWeeklySaturday] = useState(false);
  const [weeklySunday, setWeeklySunday] = useState(false);
  const [weeklyEveryXWeeks, setWeeklyEveryXWeeks] = useState('2');
  const [showHourlyConfig, setShowHourlyConfig] = useState(false);
  const [hourlyConfig, setHourlyConfig] = useState({});

  React.useEffect(() => {
    if (Object.keys(initialConfig).length > 0) {
      setWeeklyMonday(initialConfig.days?.monday !== undefined ? initialConfig.days.monday : true);
      setWeeklyTuesday(initialConfig.days?.tuesday !== undefined ? initialConfig.days.tuesday : true);
      setWeeklyWednesday(initialConfig.days?.wednesday !== undefined ? initialConfig.days.wednesday : true);
      setWeeklyThursday(initialConfig.days?.thursday !== undefined ? initialConfig.days.thursday : true);
      setWeeklyFriday(initialConfig.days?.friday !== undefined ? initialConfig.days.friday : true);
      setWeeklySaturday(initialConfig.days?.saturday || false);
      setWeeklySunday(initialConfig.days?.sunday || false);
      setWeeklyEveryXWeeks(initialConfig.everyXWeeks || '2');
      setShowHourlyConfig(!!initialConfig.hourlyConfig);
      setHourlyConfig(initialConfig.hourlyConfig || {});
    }
  }, [initialConfig]);

  const currentDays = { monday: weeklyMonday, tuesday: weeklyTuesday, wednesday: weeklyWednesday, thursday: weeklyThursday, friday: weeklyFriday, saturday: weeklySaturday, sunday: weeklySunday };

  const handleConfigChange = (overrides = {}) => {
    onConfigChange({ everyXWeeks: weeklyEveryXWeeks, days: currentDays, hourlyConfig: showHourlyConfig ? hourlyConfig : null, ...overrides });
  };

  const handleDayChange = (day, checked) => {
    const newDays = { ...currentDays, [day]: checked };
    if (!checked && !Object.values(newDays).some(v => v)) return;
    const setters = { monday: setWeeklyMonday, tuesday: setWeeklyTuesday, wednesday: setWeeklyWednesday, thursday: setWeeklyThursday, friday: setWeeklyFriday, saturday: setWeeklySaturday, sunday: setWeeklySunday };
    setters[day](checked);
    handleConfigChange({ days: newDays });
  };

  if (isViewMode) {
    const activeDays = DAYS.filter(d => currentDays[d]).map(d => d.charAt(0).toUpperCase() + d.slice(1));
    return (
      <SpaceBetween size="s">
        <Box>
          <Box variant="awsui-key-label">Days</Box>
          <Val>{activeDays.join(', ') || '—'}</Val>
        </Box>
        {showHourlyConfig && hourlyConfig && Object.keys(hourlyConfig).length > 0 && (
          <Box>
            <Box variant="awsui-key-label">Hourly configuration</Box>
            <HourlyTab isViewMode={true} onConfigChange={() => {}} initialConfig={hourlyConfig} />
          </Box>
        )}
      </SpaceBetween>
    );
  }

  return (
    <SpaceBetween size="m">
      <SpaceBetween size="m">
        <Grid gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}>
          <Checkbox checked={weeklyMonday} onChange={({ detail }) => handleDayChange('monday', detail.checked)}>Monday</Checkbox>
          <Checkbox checked={weeklyTuesday} onChange={({ detail }) => handleDayChange('tuesday', detail.checked)}>Tuesday</Checkbox>
          <Checkbox checked={weeklyWednesday} onChange={({ detail }) => handleDayChange('wednesday', detail.checked)}>Wednesday</Checkbox>
          <Checkbox checked={weeklyThursday} onChange={({ detail }) => handleDayChange('thursday', detail.checked)}>Thursday</Checkbox>
        </Grid>
        <Grid gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}>
          <Checkbox checked={weeklyFriday} onChange={({ detail }) => handleDayChange('friday', detail.checked)}>Friday</Checkbox>
          <Checkbox checked={weeklySaturday} onChange={({ detail }) => handleDayChange('saturday', detail.checked)}>Saturday</Checkbox>
          <Checkbox checked={weeklySunday} onChange={({ detail }) => handleDayChange('sunday', detail.checked)}>Sunday</Checkbox>
          <Box />
        </Grid>
      </SpaceBetween>

      <Box>
        <Button variant="normal" onClick={() => { setShowHourlyConfig(!showHourlyConfig); handleConfigChange({ hourlyConfig: !showHourlyConfig ? hourlyConfig : null }); }}>
          {showHourlyConfig ? 'Hide' : 'Add'} Hourly Configuration
        </Button>
      </Box>

      {showHourlyConfig && (
        <Box padding={{ left: 'l' }}>
          <Box variant="h3">Hourly Configuration</Box>
          <HourlyTab isViewMode={false} onConfigChange={(config) => { setHourlyConfig(config); handleConfigChange({ hourlyConfig: config }); }} initialConfig={initialConfig.hourlyConfig || { option: 'interval', interval: '1', selectedHours: [], rangeStart: '9', rangeEnd: '17', specificMinute: '0' }} />
        </Box>
      )}
    </SpaceBetween>
  );
};

export default WeeklyTab;
